import React, { useState, useEffect } from "react";
import styles from "./sidebar-fleet-link.module.scss";
import classNames from "classnames";
import EmployeesIcon from "@assets/images/employees-icon.svg";
import { NavLink, useLocation } from "react-router-dom";
import { usePrevious } from "@hooks/usePrevious";
import { HomeRouterNames } from "@modules/home/config/home-router.names";
import Image from "material-ui-image";
import { Collapse, List, ListItem } from "@material-ui/core";

export const SidebarFleetLink: React.FC = () => {
  const location = useLocation();
  const prevLocation = usePrevious(location);

  const isFleetRoute =
    location.pathname.toLowerCase().startsWith(`/${HomeRouterNames.FLEET}`) ||
    location.pathname.toLowerCase().startsWith(`/${HomeRouterNames.INCIDENTS}`) ||
    location.pathname.toLowerCase().startsWith("/damage") ||
    location.pathname.toLowerCase().startsWith(`/${HomeRouterNames.FLEET_ADMIN_NOTIFICATIONS}`);

  const [open, setOpen] = useState<boolean>(isFleetRoute);

  const handleClick = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  useEffect(() => {
    if (location !== prevLocation) {
      const wasFleet =
        prevLocation?.pathname?.toLowerCase().startsWith(`/${HomeRouterNames.FLEET}`) ||
        prevLocation?.pathname?.toLowerCase().startsWith(`/${HomeRouterNames.INCIDENTS}`) ||
        prevLocation?.pathname?.toLowerCase().startsWith("/damage") ||
        prevLocation?.pathname?.toLowerCase().startsWith(`/${HomeRouterNames.FLEET_ADMIN_NOTIFICATIONS}`);

      if (isFleetRoute && !wasFleet) {
        setOpen(true);
      } else if (!isFleetRoute) {
        setOpen(false);
      }
    }
  }, [location, isFleetRoute, prevLocation]);

  return (
    <>
      <div
        onClick={handleClick}
        className={classNames(styles.Container, {
          [styles.Active]: open && isFleetRoute,
        })}
      >
        <div className={styles.ImageWrapper}>
          <Image
            src={EmployeesIcon}
            alt=""
            disableSpinner
            animationDuration={700}
          />
        </div>

        <span>Fleet Management</span>
      </div>

      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <ListItem
            className={styles.ListItem}
            component={NavLink}
            to={`/${HomeRouterNames.FLEET}`}
            exact
            activeClassName={styles.ListItemActive}
          >
            - Inspections
          </ListItem>
          <ListItem
            className={styles.ListItem}
            component={NavLink}
            to={`/${HomeRouterNames.FLEET_NOTIFICATION_POPUPS}`}
            activeClassName={styles.ListItemActive}
          >
            - Notification Popups
          </ListItem>
          <ListItem
            className={styles.ListItem}
            component={NavLink}
            to={`/${HomeRouterNames.FLEET_VEHICLES}`}
            activeClassName={styles.ListItemActive}
          >
            - Vehicles
          </ListItem>
          <ListItem
            className={styles.ListItem}
            component={NavLink}
            to={`/${HomeRouterNames.FLEET_ADMIN_NOTIFICATIONS}`}
            activeClassName={styles.ListItemActive}
          >
            - Admin Notifications
          </ListItem>
          <ListItem
            className={styles.ListItem}
            component={NavLink}
            to={`/${HomeRouterNames.FLEET_ALERTS}`}
            activeClassName={styles.ListItemActive}
          >
            - Alerts
          </ListItem>
          <ListItem
            className={styles.ListItem}
            component={NavLink}
            to={`/${HomeRouterNames.INCIDENTS}`}
            isActive={(_match: unknown, location: { pathname: string }) =>
              location.pathname.toLowerCase().startsWith(`/${HomeRouterNames.INCIDENTS}`) ||
              location.pathname.toLowerCase().startsWith(`/${HomeRouterNames.FLEET_HEALTH_REPORT}`)
            }
            activeClassName={styles.ListItemActive}
          >
            - Reports
          </ListItem>
          <ListItem
            className={styles.ListItem}
            component={NavLink}
            to={`/${HomeRouterNames.FLEET_AI_INSIGHTS}`}
            activeClassName={styles.ListItemActive}
          >
            - AI Insights
          </ListItem>
          <ListItem
            className={styles.ListItem}
            component={NavLink}
            to={`/${HomeRouterNames.FLEET_MAINTENANCE}`}
            activeClassName={styles.ListItemActive}
          >
            - Maintenance
          </ListItem>
          {/* <ListItem
            className={styles.ListItem}
            component={NavLink}
            to={`/${HomeRouterNames.FLEET_SETTINGS}`}
            activeClassName={styles.ListItemActive}
          >
            - Settings
          </ListItem> */}
        </List>
      </Collapse>
    </>
  );
};
